/* assets/gw-cart-preview.js — the engraving card in the cart, drawn
   (2026-10-06). A board line with a design (properties Design + Text)
   renders, in snippets/line-item.liquid, a card with an empty <svg
   data-gw-cart-pv data-idx data-l1 data-l2> and the words in the style's
   font as a fallback. This script draws the svg with the same engine as
   the product page's big preview (window.GW_TILES_ENGINE) and the same
   ornaments (#gw-orn-*): on a board page both are there already, elsewhere
   assets/gw-pv-defs.js and assets/gw-pv-engine.js are loaded once, from
   the URLs snippets/gw-cart-preview.liquid leaves in window.GW_PV_*_URL
   (the fonts are that snippet's @font-face rules), with the same per-style
   numbers (GW_PV, a copy of gw-engraving's). Drawn: the card gets
   .is-drawn and the fallback lines hide. The drawer is display:none until
   opened and the engine measures text, so a card is drawn once it has a
   box; the drawer's re-renders (section rendering replaces its content)
   and its opening are caught by one MutationObserver. Line 2 of stacked
   styles is stored as "EST. / 2026" — the slashes go, the engine stacks it
   itself. */
(function () {
  if (window.GW_CART_PV) return;
  window.GW_CART_PV = 1;
  var GW_PV = {"0":{"l1":{"font":"gwAgua","size":100,"stroke":1.4},"l2":{"font":"gwCinzel","size":37.6,"stroke":1.11,"dy":51.5,"align":"right","inset":8,"upper":true,"avoid":{"mode":"slot","pad":5,"slideCost":0.35}},"orn":[{"id":"s1u","anchor":"span","x0":-13.2,"x1":0,"y0":11.3,"y1":18.7,"stretch":true}]},"1":{"l1":{"font":"gwAqua","size":100,"stroke":0.73},"l2":{"font":"gwCinzel","size":43.2,"stroke":0.84,"dy":41.5,"align":"center","upper":true,"avoid":{"mode":"slot","pad":5,"slideCost":0.55}}},"2":{"l1":{"font":"gwNoto","size":100},"l2":{"font":"gwNoto","size":62,"stackRight":true,"gap":42,"lh":72,"mid":-4.7,"splitDigits":true,"upper":true,"alignInk":true},"orn":[{"id":"s3bar","anchor":"after","x0":18,"x1":22,"y0":-132.4,"y1":85.7,"fitText":true}]},"3":{"l1":{"font":"gwMaj","size":100,"stroke":0.82},"l2":{"font":"gwCinzel","size":27.8,"stroke":1.48,"dy":24,"align":"right","inset":40.8,"upper":true,"avoid":{"mode":"slot","pad":4,"slideCost":0.35}},"orn":[{"id":"s4hat","anchor":"frac","fx0":0.486,"fx1":0.658,"y0":-73.7,"y1":-39.8,"keepRatio":true,"pin":"left","avoid":{"mode":"above","pad":5,"slide":[0.22,0.8],"maxLift":55}}],"boardWidth":120},"4":{"l1":{"font":"gwAgua","size":100,"stroke":1.37},"orn":[{"id":"s5l","anchor":"inkStart","x0":-221.7,"x1":6.8,"y0":-44.8,"y1":-10.4,"stretch":true},{"id":"s5r","anchor":"after","x0":5.6,"x1":546.3,"y0":-57.4,"y1":-21.5,"stretch":true}]},"5":{"l1":{"font":"gwCaladea","size":100}},"6":{"l1":{"font":"gwMontB","size":100,"track":0.005},"l2":{"font":"gwSans","size":63.8,"stackRight":true,"gap":64.9,"lh":67.0,"mid":-23.05},"orn":[{"id":"s7flame","anchor":"span","x0":-104.0,"x1":-17.0,"y0":-96.3,"y1":16.4,"keepRatio":true,"pin":"left"},{"id":"s7fork","anchor":"after","x0":8.6,"x1":47.2,"y0":-143.2,"y1":64.1,"keepRatio":true,"pin":"left"}]},"7":{"l1":{"font":"gwMontM","size":100,"track":0.196},"l2":{"font":"gwMontM","size":100,"dy":131.2,"align":"center","track":0.2,"upper":true},"orn":[{"id":"s8pin","anchor":"span","x0":-238.7,"x1":-61.3,"y0":-149.5,"y1":109.7,"keepRatio":true,"pin":"left","spanAll":true}]}};
  var SEL = '.gw-eng-card[data-gw-pv-card]';
  var loads = {}, mk = null;

  /* a script once, by name: window.GW_PV_<NAME>_URL (gw-cart-preview.liquid) */
  function load(name, ready) {
    if (ready()) return Promise.resolve();
    if (loads[name]) return loads[name];
    var url = window['GW_PV_' + name + '_URL'];
    if (!url) return Promise.reject(new Error('no ' + name + ' url'));
    loads[name] = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function () { if (ready()) res(); else rej(new Error(name + ' missing')); };
      s.onerror = function () { loads[name] = null; rej(new Error(name + ' failed')); };
      document.head.appendChild(s);
    });
    return loads[name];
  }
  function engine() {
    return load('DEFS', function () { return !!document.getElementById('gw-orn-s1u'); })   // the ornaments: on a board page already
      .then(function () { return load('ENGINE', function () { return !!window.GW_TILES_ENGINE; }); })
      .then(function () { return window.GW_TILES_ENGINE; });
  }

  function drawCard(card) {
    if (card.hasAttribute('data-gw-drawn') || card.hasAttribute('data-gw-nodraw')) return;
    var svg = card.querySelector('svg[data-gw-cart-pv]');
    if (!svg || !svg.getClientRects().length) return;          // no box yet (the drawer is closed): later
    var idx = parseInt(svg.getAttribute('data-idx'), 10);
    var l1 = svg.getAttribute('data-l1') || '';
    var l2 = (svg.getAttribute('data-l2') || '').replace(/ \/ /g, ' ');
    if (!(idx >= 0) || !GW_PV[String(idx)] || !l1.replace(/\s+/g, '')) { card.setAttribute('data-gw-nodraw', '1'); return; }
    card.setAttribute('data-gw-drawn', '1');
    engine().then(function (E) {
      var p = (mk || (mk = E(GW_PV)))(null, { svg: svg, compact: true, designIndex: idx });
      if (!p) throw new Error('no preview');
      return p.warm().then(function () {
        var ok = false;
        try { ok = p.draw(idx, l1, l2, false); } catch (e) { ok = false; }
        if (!ok) throw new Error('not drawn');
        card.classList.add('is-drawn');
      });
    }).catch(function () {
      card.removeAttribute('data-gw-drawn');
      if (svg.getClientRects().length) card.setAttribute('data-gw-nodraw', '1');   // it had a box and still failed: the fallback stays
    });
  }

  function scan() { [].forEach.call(document.querySelectorAll(SEL), drawCard); }
  var timer = 0;
  function soon() { clearTimeout(timer); timer = setTimeout(scan, 40); }

  if (window.MutationObserver) {
    new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'style'] });
  }
  document.addEventListener('cart:refresh', soon);
  document.addEventListener('cart:change', soon);
  window.addEventListener('pageshow', soon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();